export default __webpack_public_path__ + "static/media/q5_step3.d0650a70.png";